import * as z from "zod/v4";

export const salesChannelSchema = z.object({
  id: z.string(),
  name: z.string(),
});
